<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-fill_de_weight`]" width="1em" height="1em" v-bind="$attrs"><path d="M13.5437 5.98484C13.583 5.98483 13.6211 5.99861 13.6513 6.02378C13.6815 6.04895 13.7019 6.08392 13.709 6.12259L13.7117 6.15283V13.5444C13.7117 13.5837 13.6979 13.6218 13.6727 13.652C13.6476 13.6822 13.6126 13.7026 13.5739 13.7097L13.5437 13.7124H6.15213C6.11281 13.7124 6.07473 13.6986 6.04453 13.6734C6.01432 13.6483 5.9939 13.6133 5.98683 13.5746L5.98414 13.5444V10.0166H2.45635C2.41703 10.0166 2.37896 10.0028 2.34875 9.97766C2.31854 9.95249 2.29813 9.91752 2.29105 9.87885L2.28836 9.84861V2.45705C2.28835 2.41773 2.30213 2.37966 2.3273 2.34945C2.35247 2.31925 2.38744 2.29883 2.42611 2.29175L2.45635 2.28906H9.84791C9.88723 2.28905 9.9253 2.30283 9.95551 2.328C9.98571 2.35317 10.0061 2.38814 10.0132 2.42681L10.0159 2.45705V5.98484H5.98414V10.0166H10.0159V5.98484H13.5437Z"/></svg>
</template>
<script>

export default {
  name: 'IconFillDeWeight',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
